import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';
import { cn } from '../lib/cn.js';
import { HelpHint } from './help-hint.js';
import { Table } from './table.js';
/**
 * Следующее состояние по клику на колонку `key`: чужая колонка — её
 * направление по умолчанию; та же — направление переворачивается.
 */
export function nextSort(current, key, defaultDirection = 'desc') {
    if (current?.key !== key)
        return { key, dir: defaultDirection };
    return { key, dir: current.dir === 'asc' ? 'desc' : 'asc' };
}
function defaultHintLabel(children) {
    return typeof children === 'string' || typeof children === 'number'
        ? `Что значит «${children}»`
        : 'Пояснение к колонке';
}
const DIR_LABEL = {
    asc: 'по возрастанию',
    desc: 'по убыванию',
};
/**
 * Сортируемый заголовок `Table`: `<th aria-sort>` с кнопкой внутри.
 *
 * Сортировка серверная, когда данные постраничные на сервере: заголовок
 * сообщает намерение, а страницу на клиенте никто не пересортировывает (на
 * странице 3 из 20 это была бы ложь). Клиентская — когда все строки уже на
 * странице: тогда вызывающий код сортирует их сам.
 * Значок: ⇅ — колонка сортируемая, но не активная; ↑/↓ — активное направление.
 */
export function SortableHeader({ sortKey, sort, onSortChange, defaultDirection = 'desc', align = 'left', indicator = 'start', hint, hintLabel, className, children, ...props }) {
    const active = sort?.key === sortKey ? sort.dir : null;
    const ariaSort = active === 'asc' ? 'ascending' : active === 'desc' ? 'descending' : 'none';
    const Icon = active === 'asc' ? ArrowUp : active === 'desc' ? ArrowDown : ArrowUpDown;
    const next = nextSort(sort, sortKey, defaultDirection);
    const button = (_jsxs("button", { type: "button", onClick: () => onSortChange(next), title: `Сортировать ${DIR_LABEL[next.dir]}`, className: cn('group inline-flex items-center gap-1 rounded-[var(--radius-1)] font-medium hover:text-[var(--color-text-primary)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-border-focus)]', align === 'right' && indicator === 'start' && 'flex-row-reverse', active ? 'text-[var(--color-text-primary)]' : 'text-[var(--color-text-muted)]'), children: [_jsx("span", { children: children }), _jsx(Icon, { "aria-hidden": true, className: cn('h-3.5 w-3.5 shrink-0', active ? 'opacity-100' : 'opacity-40 group-hover:opacity-80') })] }));
    return (_jsx(Table.HeaderCell, { "aria-sort": ariaSort, className: cn(align === 'right' && 'text-right', className), ...props, children: hint ? (_jsxs("span", { className: cn('inline-flex items-center gap-0.5 align-middle', align === 'right' && indicator === 'start' && 'flex-row-reverse'), children: [button, _jsx(HelpHint, { label: hintLabel ?? defaultHintLabel(children), children: hint })] })) : (button) }));
}
//# sourceMappingURL=sortable-header.js.map